import type { Component } from 'solid-js'
import { For, Show } from 'solid-js'
import Avatar from '~/components/Avatar'
import Button from '~/components/Button'
import ButtonGroup from '~/components/ButtonGroup'
import Card from '~/components/Card'
import Chip from '~/components/Chip'
import Icon from '~/components/Icon'
import { P } from '~/utils/permissions'
import type { TabContactosProps } from './types'

const TabContactos: Component<TabContactosProps> = props => {
  return (
    <>
      <div class="flex justify-end mb-4">
        <Show when={props.can(P.customers.update)}>
          <Button size="sm" variant="soft" color="primary" onClick={() => props.openContactModal()} prependIcon="material-symbols-light:add">
            Nuevo contacto
          </Button>
        </Show>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <For each={props.data.contacts ?? []} fallback={<p class="text-foreground-subtle col-span-full">Sin contactos registrados.</p>}>
          {contact => (
            <Card class="h-full">
              <Card.Body>
                {/* Las acciones van en la cabecera: al pie obligaban a reservar
                    una franja bajo los datos y la tarjeta quedaba con un hueco. */}
                <div class="flex items-center justify-between gap-2">
                  <div class="flex items-center gap-3 min-w-0">
                    <Avatar alt={contact.name} size={40} class="rounded-full shrink-0" />
                    <div class="min-w-0">
                      <p class="font-semibold text-foreground truncate">{contact.name}</p>
                      <Show when={contact.position}>
                        <p class="text-xs text-foreground-subtle truncate">{contact.position}</p>
                      </Show>
                    </div>
                  </div>
                  <div class="flex shrink-0 items-center gap-1">
                    <Show when={contact.principal}>
                      <Chip size="xs" variant="soft" color="success">
                        Principal
                      </Chip>
                    </Show>
                    <ButtonGroup size="xs" variant="text">
                      <Show when={props.can(P.customers.update)}>
                        <Button color="warning" onClick={() => props.openContactModal(contact)} icon="material-symbols-light:edit-outline" tooltip="Editar contacto" aria-label="Editar contacto" />
                      </Show>
                      <Show when={props.can(P.customers.delete)}>
                        <Button
                          color="danger"
                          onClick={() => props.removeContact(contact.id)}
                          icon="material-symbols-light:delete-outline"
                          tooltip="Eliminar contacto"
                          aria-label="Eliminar contacto"
                        />
                      </Show>
                    </ButtonGroup>
                  </div>
                </div>

                <div class="h-px bg-border my-3" />

                <div class="space-y-2">
                  <Show when={contact.email}>
                    <a href={`mailto:${contact.email}`} class="flex items-center gap-2 text-sm text-foreground-subtle hover:text-primary-500 min-w-0">
                      <span class="size-7 rounded-lg bg-primary-soft text-primary flex items-center justify-center shrink-0">
                        <Icon icon="material-symbols-light:mail-outline" size={15} />
                      </span>
                      <span class="min-w-0 truncate">{contact.email}</span>
                    </a>
                  </Show>
                  <Show when={contact.phone}>
                    <a href={`tel:${contact.phone}`} class="flex items-center gap-2 text-sm text-foreground-subtle hover:text-primary-500 min-w-0">
                      <span class="size-7 rounded-lg bg-primary-soft text-primary flex items-center justify-center shrink-0">
                        <Icon icon="material-symbols-light:call-outline" size={15} />
                      </span>
                      <span class="min-w-0 truncate">{contact.phone}</span>
                    </a>
                  </Show>
                  <Show when={contact.celular}>
                    <a href={`tel:${contact.celular}`} class="flex items-center gap-2 text-sm text-foreground-subtle hover:text-primary-500 min-w-0">
                      <span class="size-7 rounded-lg bg-primary-soft text-primary flex items-center justify-center shrink-0">
                        <Icon icon="material-symbols-light:smartphone-outline" size={15} />
                      </span>
                      <span class="min-w-0 truncate">{contact.celular}</span>
                    </a>
                  </Show>
                  <Show when={!contact.email && !contact.phone && !contact.celular}>
                    <p class="text-xs text-foreground-subtle/60 italic">Sin datos de contacto.</p>
                  </Show>
                </div>

                <Show when={contact.notes}>
                  <p class="mt-3 text-xs text-foreground-subtle line-clamp-2">{contact.notes}</p>
                </Show>
              </Card.Body>
            </Card>
          )}
        </For>
      </div>
    </>
  )
}

export default TabContactos
